import {
  ActionType,
  ConditionType,
  TargetType,
} from '@src/components/generated/graphql';
import { INTERACTION_TYPES } from 'util/constants';

export enum NODES_TYPES {
  EVENT = 'event',
  CONDITION = 'condition',
  ACTION = 'action',
  TARGET = 'target',
  EVENT_LINK = 'event_link',
  QUEST = 'quest',
  COLLECTIBLE = 'collectible',
  DESTROYABLE = 'destroyable',
}

export enum HANDLES_TYPES {
  EVENT = 'event',
  CONDITION = 'condition',
  ACTION = 'action',
  TARGET = 'target',
  EVENT_LINK = 'event_link',
  QUEST = 'quest',
  COLLECTIBLE = 'collectible',
  DESTROYABLE = 'destroyable',
}

export enum QUEST_TYPES {
  SEQUENTIAL = 'sequential',
  PARALLEL = 'parallel',
}

export enum EDGES_TYPES {
  DELETABLE_EDGE = 'deletableEdge',
}

export enum CAMERA_FLY_PRESET_TYPES {
  CIRCLE = 'circle',
  DRONIE = 'dronie',
  HELIX = 'helix',
  ROCKET = 'rocket',
}

// [target, sources]
export const SOURCES_NODE_ALLOWED = new Map([
  [NODES_TYPES.CONDITION, [NODES_TYPES.EVENT]],
  [NODES_TYPES.COLLECTIBLE, [NODES_TYPES.QUEST]],
  [NODES_TYPES.DESTROYABLE, [NODES_TYPES.QUEST]],
  [
    NODES_TYPES.ACTION,
    [
      NODES_TYPES.EVENT,
      NODES_TYPES.QUEST,
      NODES_TYPES.COLLECTIBLE,
      NODES_TYPES.DESTROYABLE,
    ],
  ],
  [NODES_TYPES.TARGET, [NODES_TYPES.ACTION]],
  [NODES_TYPES.EVENT_LINK, [NODES_TYPES.EVENT, NODES_TYPES.QUEST]],
  [NODES_TYPES.EVENT, [NODES_TYPES.EVENT_LINK]],
  [NODES_TYPES.QUEST, [NODES_TYPES.EVENT_LINK]],
]);
// [source handle type, target handle type]
export const FORBIDDEN_HANDLES_CONNECTION = new Map([
  [HANDLES_TYPES.QUEST, `${HANDLES_TYPES.COLLECTIBLE}-input`],
  [HANDLES_TYPES.QUEST, `${HANDLES_TYPES.DESTROYABLE}-input`],
  [HANDLES_TYPES.EVENT, `${HANDLES_TYPES.COLLECTIBLE}-input`],
  [HANDLES_TYPES.EVENT, `${HANDLES_TYPES.DESTROYABLE}-input`],
  [HANDLES_TYPES.COLLECTIBLE, `${HANDLES_TYPES.EVENT}-input`],
  [HANDLES_TYPES.DESTROYABLE, `${HANDLES_TYPES.EVENT}-input`],
]);

export const DEFAULT_PRESET_ADVANCED_SETTINGS = {
  [CAMERA_FLY_PRESET_TYPES.CIRCLE]: {
    radius: 10,
    height: 7,
  },
  [CAMERA_FLY_PRESET_TYPES.DRONIE]: {
    radius: 5,
    height: 2,
    toRadius: 20,
    toHeight: 13,
  },
  [CAMERA_FLY_PRESET_TYPES.HELIX]: {
    radius: 5,
    height: 2,
    toRadius: 18,
    toHeight: 10,
  },
  [CAMERA_FLY_PRESET_TYPES.ROCKET]: {
    radius: 5,
    height: 2,
    toHeight: 25,
  },
};

export const DEFAULT_DATA_FOR_NODES = {
  [NODES_TYPES.ACTION]: {
    type: ActionType.Move,
    params: {
      position: { x: 0, y: 0, z: 0 },
      easing: 'linear',
    },
    delay: 0,
    duration: 10000,
  },
  [NODES_TYPES.CONDITION]: {
    type: ConditionType.Interaction,
    params: {
      interactionType: INTERACTION_TYPES.COLLISION,
      targetId: '',
    },
  },
  [NODES_TYPES.TARGET]: {
    type: TargetType.SceneObject,
    objectId: '',
  },
  [NODES_TYPES.EVENT]: {
    name: 'New*',
  },
  [NODES_TYPES.QUEST]: {
    name: 'New*',
    questType: QUEST_TYPES.SEQUENTIAL,
  },
  [NODES_TYPES.COLLECTIBLE]: {
    type: ConditionType.Interaction,
    params: {
      interactionType: INTERACTION_TYPES.COLLISION,
      targetId: '',
      audioType: 'default',
      animationType: 'fadeOut',
    },
  },
  [NODES_TYPES.DESTROYABLE]: {
    type: ConditionType.Interaction,
    params: {
      interactionType: INTERACTION_TYPES.DESTROYABLE,
      targetId: '',
      lifespan: 3,
    },
  },
};

export const SUPPORTED_ACTIONS_PREVIEW = [
  ActionType.MoveMainCamera,
  ActionType.SwitchBetweenCameras,
  ActionType.RotateMainCamera,
];

export enum NPCTypes {
  VILLAGER = 0,
  ANIMAL = 1,
  FOLLOWABLE = 2,
  CONTROLLABLE = 3,
}

export const AVAILABLE_FOR_CONNECT_NODES = {
  [NODES_TYPES.EVENT]: [
    NODES_TYPES.CONDITION,
    NODES_TYPES.ACTION,
    NODES_TYPES.EVENT_LINK,
  ],
  [NODES_TYPES.QUEST]: [
    NODES_TYPES.COLLECTIBLE,
    NODES_TYPES.DESTROYABLE,
    NODES_TYPES.ACTION,
    NODES_TYPES.EVENT_LINK,
  ],
  [NODES_TYPES.ACTION]: [],
  [NODES_TYPES.COLLECTIBLE]: [NODES_TYPES.ACTION],
  [NODES_TYPES.DESTROYABLE]: [NODES_TYPES.ACTION],
  [NODES_TYPES.CONDITION]: [],
  [NODES_TYPES.EVENT_LINK]: [NODES_TYPES.EVENT, NODES_TYPES.QUEST],
  [NODES_TYPES.TARGET]: [],
};

export const CLEAR_SELECTED_NODE_EVENT = 'clear_selected_node';

export enum NPCAction {
  MOVE = 'move',
}

export enum RequiredNPCAnimationsTypes {
  IDLE = 'IDLE',
  WALK = 'WALK',
}
